import React from "react";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { withRouter } from "react-router-dom";
const HomeChart = ({ symbol, time, color, location, data }) => {
  // useEffect(() => {
  //   // clearSparklines();
  //   if (sparklineData && sparklineData.length > 0&&location.pathname!=="/favourite") {
  //     let coin = sparklineData.filter((i, index) => i.currency === symbol);

  //     setData(coin[0].prices.map((i) => i));
  //   }
  // if (favouriteSparklineData && favouriteSparklineData.length > 0&&location.pathname==="/favourite") {
  //   let coin = favouriteSparklineData.filter((i, index) => i.currency === symbol);

  //   setData(coin[0].prices.map((i) => i));
  // }
  // }, [sparklineData,favouriteSparklineData]);

  // useEffect(() => {

  //   if (sparklineData && sparklineData.length > 0) {
  //     console.log( sparklineData.filter((i, index) => i.currency === symbol))
  //     setData(
  //       sparklineData
  //         .filter((i, index) => i.currency === symbol)[0]
  //         .prices?.map((i) => i)
  //     );
  //   }
  // }, [sparklineData]);

  return (
    <Sparklines data={data} style={{ width: "150px" }}>
      <SparklinesLine
        color={color}
        style={{ fill: "none", strokeWidth: "4" }}
      />
    </Sparklines>
  );
};
export default withRouter(HomeChart);

// data && data.length > 0 ? (
//   <Sparklines
//     data={data && data?.length > 0 ? data : []}
//     style={{ width: "150px" }}
//   >
//     <SparklinesLine
//       color={color}
//       style={{ fill: "none", strokeWidth: "4" }}
//     />
//   </Sparklines>
// ) : (
